import { render } from "./PeopleScreen.vue?vue&type=template&id=462bffba&scoped=true"
import script from "./PeopleScreen.vue?vue&type=script&lang=js"
export * from "./PeopleScreen.vue?vue&type=script&lang=js"

import "./PeopleScreen.vue?vue&type=style&index=0&id=462bffba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462bffba"]])

export default __exports__